export async function setup() {
  const logoData = [];
  //Default English
  logoData["XL"] = require("../assets/logo.png");
  logoData["bth"] = require("../assets/bth.png");
  return logoData;
}
